import React from 'react';
import { User, Mail, Phone, Star, Inbox } from 'lucide-react';

export default function ContactList({ contacts }) {
  if (!contacts || contacts.length === 0) {
    return (
      <div className="empty-state">
        <Inbox size={48} className="empty-icon" />
        <h3>No contacts on file</h3>
        <p>
          We don't have any other contacts associated with your account yet.
          Reach out to your account team to add additional points of contact.
        </p>
      </div>
    );
  }

  return (
    <div className="portal-contact-cards">
      {contacts.map((c) => {
        const fullName =
          [c.first_name, c.last_name].filter(Boolean).join(' ') || '—';
        return (
          <div key={c.id} className="portal-contact-card">
            <div className="portal-contact-header">
              <User size={18} />
              <span className="portal-contact-name">{fullName}</span>
              {c.is_primary_contact && (
                <span className="portal-contact-primary-badge">
                  <Star size={11} /> Primary
                </span>
              )}
            </div>
            {c.title && <div className="portal-contact-title">{c.title}</div>}
            <div className="portal-contact-meta">
              {c.email && (
                <a
                  href={`mailto:${c.email}`}
                  className="portal-contact-meta-row"
                >
                  <Mail size={14} />
                  <span>{c.email}</span>
                </a>
              )}
              {c.phone && (
                <a href={`tel:${c.phone}`} className="portal-contact-meta-row">
                  <Phone size={14} />
                  <span>{c.phone}</span>
                </a>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
